module.exports = __webpack_public_path__ + "img/location-confirm.5f724258.png";